import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

import Swiper from 'swiper/bundle';
import { smootherPause } from "./smoother";

gsap.registerPlugin(ScrollTrigger);

export const imgSliderWithText = () => {
    const select = document.querySelectorAll('.img-slider-with-text');
    select.forEach( e => {
        let gap;
        e.classList.contains('img-slider-with-text--img-overflow') ? gap = 30 : gap = 1;
        const textGrp = e.querySelector('.img-slider-with-text__text-group');
        const imgGrp = e.querySelector('.img-slider-with-text__img-slider');
        const prevBtn = e.querySelector('.swiper-button--prev');
        const nextBtn = e.querySelector('.swiper-button--next');
        const carousel = e.querySelector(".img-slider-with-text__swiper-pagination.swiper-pagination");
    
        let textGrpSwiper = new Swiper(textGrp, {
            spaceBetween: 30,
            speed: 300,
            effect: 'fade',
            allowTouchMove: false
        })

        let imgGrpSwiper = new Swiper(imgGrp, {
            spaceBetween: gap,
            speed: 600,
            preloadImages: false,
            lazy: true,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            pagination: {
                el: carousel,
                clickable: true,
            },
            on : {
                init: () => {
                    prevBtn.disabled = false;
                    prevBtn.classList.add('pe-none');
                },
                slideChange: () => {
                    if (imgGrpSwiper.activeIndex == 0) {
                        prevBtn.disabled = false;
                        prevBtn.classList.add('pe-none');
                    } else if ( imgGrpSwiper.activeIndex == imgGrpSwiper.slides.length - 1 ) {
                        nextBtn.disabled = false;
                        nextBtn.classList.add('pe-none');
                    } else {
                        prevBtn.classList.remove('pe-none');
                        nextBtn.classList.remove('pe-none');
                    }
                },
                slidePrevTransitionStart: () => {
                    gsap.fromTo(textGrpSwiper.slides[textGrpSwiper.activeIndex].querySelector('*'), 
                    {
                        y: 0,
                        opacity: 1
                    },
                    {
                    y: '8rem',
                    opacity: 0,
                    duration: .2,
                    onComplete: () => {
                        textGrpSwiper.slidePrev();
                        gsap.fromTo(textGrpSwiper.slides[textGrpSwiper.activeIndex].querySelector('*'), 
                            {
                                y: '8rem',
                                opacity: 0
                            },
                            {
                                y: 0,
                                opacity: 1,
                                duration: .2,
                                onComplete: function() {
                                    gsap.set(this.targets(), { clearProps: "all" });             
                                }
                            }
                        )       
                    }
                })
                },
                slideNextTransitionStart: () => {
                    gsap.fromTo(textGrpSwiper.slides[textGrpSwiper.activeIndex].querySelector('*'), 
                    {
                        y: 0
                    },
                    {
                        y: '8rem',
                        opacity: 0,
                        duration: .2,
                        onComplete: () => {
                            textGrpSwiper.slideNext();        
                            gsap.fromTo(textGrpSwiper.slides[textGrpSwiper.activeIndex].querySelector('*'), 
                                {
                                    y: '8rem',
                                    opacity: 0
                                },
                                    {
                                    y: 0,
                                    opacity: 1,
                                    duration: .2,
                                    onComplete: function() {
                                        gsap.set(this.targets(), { clearProps: "all" });            
                                    }
                                }
                            )
                        }
                    }
                )
                },
                sliderMove: () => {
                    smootherPause(true);
                },
                touchEnd: () => {
                    smootherPause(false);
                }
            }
        })
    })
}